<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
    <div>
        <h2>Discounts & Coupon Codes</h2>
        <el-button
            class="el-button--corwin-green"
            icon="el-icon-plus"
            style="width: 250px"
            @click="createView"
        >
            New Discount
        </el-button>
        <div v-for="(item, index) in coupons" :key="index" class="discount">
            <h3>{{ item.name }}</h3>
            <p>
                Discount Code:
                <span class="text-uppercase">{{ item.code }}</span>
            </p>
            <p class="mb-0">Discount Type:</p>
            <p
                class="mt-0 mb-0"
                v-for="(item1, index1) in item.types.data"
                :key="index1"
            >
                {{ item1.name }}
            </p>
            <p class="mb-0">Discount Length once applied at checkout:</p>
            <p class="mt-0">{{ item.duration.name }}</p>
            <p class="mb-0" v-if="item.communities.data.length">
                Discount Active:
                <span v-for="(item2, index2) in item.communities.data"
                    ><br />{{ item2.name }}</span
                >
            </p>
            <p v-else>Discount Inactive</p>
            <p>
                Discount Expires {{ getDate(item.valid_at) }} at midnight
                Eastern time
            </p>
            <el-button
                v-if="checkValidity(item.valid_at) > 0"
                type="danger"
                style="width: 200px"
                @click="removeCoupon(item)"
                >Delete Discount</el-button
            >
            <el-button v-else type="info" style="width: 200px"
                >Delete Discount</el-button
            >
            <el-button
                class="el-button--corwin-green"
                style="width: 200px"
                @click="editView(item)"
                >Edit Discount</el-button
            >
        </div>
        <el-dialog
            :title="formTitle"
            :visible.sync="dialogVisible"
            width="40%"
            :before-close="handleClose"
        >
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item label="Discount Name" prop="name">
                    <br />
                    <el-input
                        v-model="ruleForm.name"
                        placeholder="Enter Name"
                        style="width: 50%"
                    ></el-input>
                </el-form-item>
                <el-form-item label="Discount Code" prop="code">
                    <br />
                    <el-input
                        class="el-input--uppercase"
                        v-model="ruleForm.code"
                        placeholder="Enter Code"
                        style="width: 50%"
                    ></el-input>
                </el-form-item>
                <el-form-item label="Discount Type" prop="type">
                    <el-checkbox-group v-model="ruleForm.type">
                        <br />
                        <el-checkbox
                            name="type"
                            v-for="(item, index) in couponTypes"
                            :label="item.id"
                            :key="index"
                            >{{ item.name }}</el-checkbox
                        >
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item
                    label="Discount Length once applied at checkout"
                    prop="duration"
                >
                    <br />
                    <el-radio-group v-model="ruleForm.duration">
                        <el-radio
                            v-for="(item, index) in couponDurations"
                            :key="index"
                            :label="item.id"
                            >{{ item.name }}</el-radio
                        >
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Discount Expires" prop="date1">
                    <br />
                    <el-date-picker
                        v-model="ruleForm.date1"
                        type="date"
                        placeholder="Pick a date"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        @click="handleClose"
                        type="danger"
                        style="width: 200px"
                        >Delete</el-button
                    >
                    <el-button
                        type="primary"
                        @click="submitForm('ruleForm')"
                        style="width: 200px"
                        >{{ formSubmitbtn }}</el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import auth from "@/mixins/auth";

export default {
    mixins: [auth],
    props: {},
    directives: {},
    components: {},
    data() {
        return {
            ruleForm: {
                name: "",
                code: "",
                type: [],
                duration: 1,
                date1: "",
            },
            dialogVisible: false,
            couponTypes: null,
            couponDurations: null,
            coupon: null,
            coupons: null,
            formTitle: "New Discount",
            formSubmitbtn: "Save",
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please Enter Discount Name",
                        trigger: "blur",
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "Please Enter Discount Code",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        type: "array",
                        required: true,
                        message: "Please select at least one Discount Type",
                        trigger: "change",
                    },
                ],
                duration: [
                    {
                        required: true,
                        message: "Please select discount validity",
                        trigger: "change",
                    },
                ],
                date1: [
                    {
                        type: "date",
                        required: true,
                        message: "Please pick a date",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    mounted() {
        this.getCoupons();
    },
    methods: {
        getCoupons() {
            Promise.all([
                axios.get(`/web-api/coupon-types`),
                axios.get(`/web-api/coupon-durations`),
                axios.get(`/web-api/coupon?include=duration,types,communities`),
            ]).then((responses) => {
                this.couponTypes = responses[0].data.data;
                this.couponDurations = responses[1].data.data;
                this.coupons = responses[2].data.data;
            });
        },
        createView() {
            this.formTitle = "New Discount";
            this.formSubmitbtn = "Save";
            this.resetForm();
            this.dialogVisible = true;
        },
        resetForm() {
            this.ruleForm.name = "";
            this.ruleForm.code = "";
            this.ruleForm.type = [];
            this.ruleForm.duration = 1;
            this.ruleForm.date1 = "";
        },
        handleClose() {
            this.$confirm("Are you sure to close this dialog?")
                .then((_) => {
                    this.$refs["ruleForm"].resetFields();
                    this.dialogVisible = false;
                })
                .catch((_) => {
                    // do nothing
                });
        },
        submitForm(form) {
            this.$refs[form].validate((valid) => {
                if (valid) {
                    if (this.coupon) {
                        axios
                            .put(
                                `/web-api/coupon/${this.coupon.id}`,
                                this.ruleForm,
                            )
                            .then((response) => {
                                this.$toastr("add", {
                                    title: "Update",
                                    msg: "Coupon updated successfully",
                                    clickClose: true,
                                    timeout: 1500,
                                    position: "toast-top-right",
                                    type: "success",
                                });
                                this.getCoupons();
                                this.$refs[form].resetFields();
                                this.dialogVisible = false;
                            });
                    } else {
                        axios
                            .post(`/web-api/coupon`, this.ruleForm)
                            .then((response) => {
                                this.$toastr("add", {
                                    title: "Added",
                                    msg: "Coupon added successfully",
                                    clickClose: true,
                                    timeout: 1500,
                                    position: "toast-top-right",
                                    type: "success",
                                });
                                this.getCoupons();
                                this.resetForm();
                                this.$refs[form].resetFields();
                                this.dialogVisible = false;
                            });
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        removeCoupon(coupon) {
            this.$confirm("Deletion is permanent: ARE YOU SURE?")
                .then((_) => {
                    axios
                        .delete(`/web-api/coupon/${coupon.id}`)
                        .then((response) => {
                            if (response.status == 200) {
                                this.$toastr("add", {
                                    title: "Deleted",
                                    msg: "Coupon deleted successfully",
                                    clickClose: true,
                                    timeout: 1500,
                                    position: "toast-top-right",
                                    type: "success",
                                });
                                this.getCoupons();
                            } else if (response.status == 500) {
                                this.$toastr("add", {
                                    title: "Alert",
                                    msg: "Coupon has multiple orders",
                                    clickClose: true,
                                    timeout: 1500,
                                    position: "toast-top-right",
                                    type: "warning",
                                });
                            }
                        });
                })
                .catch(() => {
                    // do nothing
                });
        },
        getDate(date) {
            return moment(date).format("MMM DD, YYYY");
        },
        checkValidity(date) {
            return moment(date).diff(moment(), "minutes");
        },
        editView(coupon) {
            axios
                .get(`/web-api/coupon/${coupon.id}/edit?include=types`)
                .then((response) => {
                    this.formTitle = "Update Discount";
                    this.formSubmitbtn = "Update";
                    this.resetForm();
                    this.coupon = response.data;
                    this.ruleForm.name = this.coupon.name;
                    this.ruleForm.code = this.coupon.code;
                    for (var i = 0; i < this.coupon.types.data.length; i++) {
                        this.ruleForm.type.push(this.coupon.types.data[i].id);
                    }
                    this.ruleForm.duration = this.coupon.coupon_duration_id;
                    this.ruleForm.date1 = new Date(this.coupon.valid_at);
                    this.dialogVisible = true;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.el-checkbox,
.el-radio {
    display: block;
}
.dialog-footer {
    text-align: left !important;
}
.discount {
    width: 50%;
    border-top: 1px solid #000;
    margin-top: 30px;
}
</style>
